import { Endpoints } from '@xver/apis';
import type {
    ListContainerResponse,
    ListContainersQueryModel,
} from '@xver/apis/v1/kufer/containers/model';
import { useActiveProjectScope, useProductAccess } from '@xver/hooks/useActiveProject';
import { useQuery } from '@tanstack/react-query';

export const CONTAINER_LIST_QUERY_KEY = ['apis.v1.kufer.containers.list'];

export function useContainerListQuery(params?: ListContainersQueryModel) {
    const { activeProjectId, isResolved } = useActiveProjectScope();
    const hasNoAccess = useProductAccess('container') === 'none';

    return useQuery<ListContainerResponse>({
        queryKey: [...CONTAINER_LIST_QUERY_KEY, activeProjectId, params],
        queryFn: () => Endpoints.v1.Kufer.Containers.listContainers(params),
        refetchInterval: 5000,
        staleTime: 0,
        gcTime: 1000 * 60 * 60 * 24,
        enabled: isResolved && !hasNoAccess,
    });
}
